<template>
  <div class="contacts">
    <template v-if="!branchNotFound">
      <v-data-table
        :fixed-header="true"
        :headers="headers"
        :items="contacts"
        single-expand
        item-key="id"
        class="elevation-1"
        height="65vh"
        :items-per-page="100"
        :footer-props="{
          'items-per-page-options': [100]
        }"
        :loading="isLoadingContacts"
        loading-text="Loading Contacts... Please wait"
      >
        <template v-slot:item.photo="{ item }">
          <v-img v-if="item.photo" :src="item.photo" aspect-ratio="1.7" height="auto" width="100px"></v-img>

          <div class="py-2" style="width: 100px" v-else>
            <v-avatar size="50px" color="grey lighten-4" tile>
              <v-icon large>mdi-account</v-icon>
            </v-avatar>
          </div>
        </template>
      </v-data-table>

      <v-fab-transition>
        <v-btn
          v-if="isAuthorized"
          v-show="isSmaller"
          dark
          color="primary darken-4"
          fixed
          bottom
          right
          fab
          @click="openNewContactDialog()"
        >
          <v-icon large>mdi-account-plus</v-icon>
        </v-btn>
      </v-fab-transition>
    </template>

    <v-container v-else>
      <v-row justify="center" align="center">
        <v-col cols="auto">
          <v-card color="white" class="pa-8" light elevation="2" :width="cardWidth">
            <div class="d-flex justify-center grey--text">
              <v-icon size="150">mdi-cancel</v-icon>
            </div>

            <div class="text-center title grey--text">
              <span class="font-weight-black">Branch</span> not available
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Contacts",
  data() {
    return {
      headers: [
        { text: "Photo", value: "photo", sortable: false },
        { text: "Name", align: "start", value: "name" },
        { text: "Phone", value: "phone", sortable: false },
        { text: "Email", align: "start", value: "email" }
      ],
      isLoadingContacts: false
    };
  },

  components: {},

  methods: {
    async getContacts() {
      var branchId = this.$route.params.branchId;

      this.isLoadingContacts = true;

      await this.$store.dispatch("getContacts", branchId).finally(() => {
        this.isLoadingContacts = false;
      });
    },

    openNewContactDialog() {
      this.$store.commit("setNewContactDialog", true);
    }
  },

  watch: {
    $route() {
      this.getContacts();
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$store.commit("setBranchVendor");
    next();
  },

  mounted() {
    this.getContacts();
  },

  computed: {
    isSmaller() {
      var name = this.$vuetify.breakpoint.name;

      if (name === "xs" || name === "sm") return true;
      else return false;
    },

    contacts() {
      return this.$store.state.contacts.contacts;
    },

    branchNotFound() {
      return this.$store.state.branches.branchNotFound;
    },

    cardWidth() {
      var name = this.$vuetify.breakpoint.name;

      if (name === "xs") {
        return "99vw";
      } else {
        return "45vw";
      }
    },

    isAuthorized() {
      return this.$store.getters.isAuthorized;
    }
  }
};
</script>

<style>
</style>